/* Presente da roleta no carrinho — Toda Up (14/10/2026). Roda no site todo (layout/theme.liquid).

   REGRAS (iguais às da Blumi):
   1. Só para quem girou NESTA campanha e deixou o e-mail (chave todaup-roleta-presente).
   2. Só com peça paga no carrinho (linha sem `_roleta` e com preço final > 0) das coleções da roleta.
   3. Só quando essas peças somam pelo menos o mínimo do prêmio.
   4. Exatamente 1 presente, marcado com a propriedade oculta `_roleta`. Cai abaixo do mínimo: sai. Volta: entra.
   5. O presente precisa custar R$ 0,00 — se um dia custar mais, ele para de entrar em vez de virar cobrança.

   SEM POLLING: confere ao carregar e quando o carrinho muda (evento `cart:updated` da gaveta, e o aviso
   `todaup-roleta:presente` da roleta). Uma conferência por vez; se o carrinho mudar no meio, roda mais uma.
   Depois de mexer, pede à gaveta para se redesenhar (`cart:refresh`). */
(function () {
  'use strict';
  var CFG = window.TodaRoleta || {};
  var K_PRES = 'todaup-roleta-presente', K_PEND = 'todaup-roleta-pendente', K_EMAIL = 'todaup-roleta-email';
  var K_SIL_FALTA = 'todaup-roleta-silencio-falta', K_SIL_EMAIL = 'todaup-roleta-silencio-email';

  function ler(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function gravar(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function apagar(k) { try { localStorage.removeItem(k); } catch (e) {} }
  function lerJson(k) { try { return JSON.parse(ler(k) || 'null'); } catch (e) { return null; } }
  // Espaço que não quebra: "R$" nunca fica numa linha e o valor na outra.
  function brl(c) { return 'R$\u00A0' + (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function whats() { return ler('todaup-roleta-contato') === 'whatsapp'; }
  function silenciado(k) { var t = parseInt(ler(k) || '0', 10); return t && t > Date.now(); }
  function silenciar(k) { gravar(k, String(Date.now() + 30 * 60 * 1000)); }
  function quando(ts) {
    var d = new Date(ts), hoje = new Date(), amanha = new Date(Date.now() + 864e5);
    var hm = ('0' + d.getHours()).slice(-2) + 'h' + ('0' + d.getMinutes()).slice(-2);
    if (d.toDateString() === hoje.toDateString()) return 'hoje às ' + hm;
    if (d.toDateString() === amanha.toDateString()) return 'amanhã às ' + hm;
    return ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2) + ' às ' + hm;
  }
  /* Mesma medição da roleta: dataLayer, Shopify.analytics, VWO e Klaviyo (perfis identificados). */
  function medir(nome, dados) {
    var d = Object.assign({ campanha: CFG.campanha || '' }, dados || {}); nome = 'roleta_' + nome;
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: nome }, d)); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(nome, d); } catch (e) {}
    try { if (window.VWO && typeof window.VWO.event === 'function') window.VWO.event(nome, d); } catch (e) {}
    try { if (window.klaviyo && typeof window.klaviyo.track === 'function') window.klaviyo.track('Roleta: ' + nome, d); } catch (e) {}
  }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/').replace(/\/$/, ''); }

  function pedir(metodo, url, corpo) {
    return fetch(root() + url, { method: metodo, credentials: 'same-origin', cache: 'no-store', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: corpo ? JSON.stringify(corpo) : undefined })
      .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }

  /* Prêmio válido só na campanha atual; de outra campanha, apaga. */
  function premio() {
    // Campanhas ativas no site (podem ser mais de uma, cada uma na sua LP): o prêmio vale se for de uma delas.
    var ativas = (CFG.campanhas && CFG.campanhas.length) ? CFG.campanhas : (CFG.campanha ? [CFG.campanha] : []);
    [K_PRES, K_PEND].forEach(function (k) { var v = lerJson(k); if (v && ativas.length && ativas.indexOf(v.campanha) < 0) apagar(k); });
    // Campanha com data de fim: depois dela o prêmio deixa de valer (e o presente sai do carrinho na conferência).
    [K_PRES, K_PEND].forEach(function (k) { var v = lerJson(k); if (v && v.fim && v.fim < Date.now()) apagar(k); });
    // Presente guardado por N horas: passou do prazo, deixa de valer (e sai do carrinho na conferência).
    var pr = lerJson(K_PRES);
    if (pr && pr.expira && pr.expira < Date.now()) { apagar(K_PRES); medir('presente_expirou'); document.dispatchEvent(new CustomEvent('todaup-roleta:expirou')); }
    return { presente: lerJson(K_PRES), pendente: lerJson(K_PEND), email: ler(K_EMAIL) };
  }

  var rodando = false, deNovo = false, falhou = false;
  async function conferir() {
    if (rodando) { deNovo = true; return; }
    rodando = true;
    var mexeu = false;
    try {
      var st = premio();
      var info = st.presente || st.pendente;
      // Quem nunca girou não paga nem uma leitura do carrinho (a não ser que um presente nosso já tenha entrado).
      if (!info && ler('todaup-roleta-linha') !== '1') { fecharCartao(); return; }
      var c = await pedir('GET', '/cart.js');
      var itens = c.items || [];
      var nossas = itens.filter(function (x) { return x.properties && x.properties._roleta; });
      var ids = {}; ((info && info.ids) || []).forEach(function (id) { ids[String(id)] = true; });
      /* Valor da linha DEPOIS dos descontos automáticos (kit, escada…) e ANTES de cupom: soma de volta o que um cupom de produto tirou. */
      // O /cart.js não informa o tipo do desconto; o cupom aparece pelo título da aplicação = o código digitado (c.discount_codes).
      var codigos = {}; (c.discount_codes || []).forEach(function (d) { if (d && d.code) codigos[String(d.code).toUpperCase()] = true; });
      function base(x) {
        var v = x.final_line_price || 0;
        (x.line_level_discount_allocations || []).forEach(function (a) { var t = a.discount_application && String(a.discount_application.title || '').toUpperCase(); if (t && codigos[t]) v += a.amount || 0; });
        return v;
      }
      var todo = !!(info && info.todo);
      var pagas = itens.filter(function (x) { return !(x.properties && x.properties._roleta) && base(x) > 0 && (todo || ids[String(x.product_id)]); });
      var total = pagas.reduce(function (s, x) { return s + base(x); }, 0);
      // "Não soma com a calcinha do kit": brinde de kit no carrinho = o presente da roleta não entra (e o que já entrou sai).
      var temBrindeKit = !!(info && info.semKit && itens.some(function (x) { return x.properties && x.properties._brinde; }));
      var minimo = (info && info.minimo) || 0;

      cartoes({ st: st, info: info, total: total, temPagas: pagas.length > 0, minimo: minimo, temBrindeKit: temBrindeKit });

      var pres = st.presente;
      var elegivel = pres && pres.handle && pagas.length > 0 && total >= minimo && !temBrindeKit;
      if (!elegivel) {
        for (var i = 0; i < nossas.length; i++) { await pedir('POST', '/cart/change.js', { id: nossas[i].key, quantity: 0 }); mexeu = true; }
        if (nossas.length) medir('presente_saiu', { total: total, motivo: !pres ? 'sem_presente' : (temBrindeKit ? 'brinde_do_kit' : (!pagas.length ? 'sem_peca' : 'abaixo_minimo')) });
        apagar('todaup-roleta-linha');
        return;
      }
      /* Presente com tamanho: sem tamanho escolhido, nada entra — e é a hora de pedir o tamanho. */
      var comTamanho = (pres.variantes || []).length > 1;
      if (comTamanho && !pres.variantId) {
        for (var q = 0; q < nossas.length; q++) { await pedir('POST', '/cart/change.js', { id: nossas[q].key, quantity: 0 }); mexeu = true; }
        pedirTamanho(pres);
        return;
      }
      if (nossas.length && pres.variantId && String(nossas[0].variant_id) !== String(pres.variantId)) {
        for (var t = 0; t < nossas.length; t++) await pedir('POST', '/cart/change.js', { id: nossas[t].key, quantity: 0 });
        nossas = []; mexeu = true; // trocou o tamanho: sai o antigo, entra o novo
      }
      if (!nossas.length) {
        if (falhou) return;
        var prod = await pedir('GET', '/products/' + encodeURIComponent(pres.handle) + '.js');
        var v = null;
        if (pres.variantId) {
          v = (prod.variants || []).filter(function (x) { return String(x.id) === String(pres.variantId); })[0];
          if (!v || !v.available) { delete pres.variantId; delete pres.tamanho; gravar(K_PRES, JSON.stringify(pres)); pedirTamanho(pres); return; }
        } else v = (prod.variants || []).filter(function (x) { return x.available; })[0];
        if (!v || v.price !== 0) return; // presente precisa custar R$ 0,00
        try {
          await pedir('POST', '/cart/add.js', { items: [{ id: v.id, quantity: 1, properties: { _roleta: '1' } }] }); mexeu = true; gravar('todaup-roleta-linha', '1');
          medir('presente_no_carrinho', { total: total, tamanho: pres.tamanho || '', cor: pres.cor || '' });
          pedir('POST', '/cart/update.js', { attributes: { Roleta: (CFG.campanha || '') + ' · presente no carrinho' } }).catch(function () {});
        }
        catch (e) { falhou = true; console.error('[roleta] não deu para colocar o presente', e); }
        return;
      }
      for (var j = 1; j < nossas.length; j++) { await pedir('POST', '/cart/change.js', { id: nossas[j].key, quantity: 0 }); mexeu = true; }
      if (nossas[0].quantity > 1) { await pedir('POST', '/cart/change.js', { id: nossas[0].key, quantity: 1 }); mexeu = true; }
    } catch (e) {
      console.error('[roleta]', e); // a próxima mudança do carrinho tenta de novo
    } finally {
      rodando = false;
      if (mexeu) document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { source: 'roleta' } }));
      if (deNovo) { deNovo = false; conferir(); }
    }
  }

  var pediuTamanho = false;
  function pedirTamanho(pres) {
    if (pediuTamanho) return; // uma vez por página, para não perseguir quem fechou
    pediuTamanho = true;
    if (document.querySelector('[data-roleta]')) { document.dispatchEvent(new CustomEvent('todaup-roleta:pedir-tamanho')); return; }
    abrirCartao('tamanho', 'Seu presente já pode ir junto: <b>escolha ' + (pres.nome ? 'a cor e ' : '') + 'o tamanho</b>.', [
      ['Escolher o tamanho', function () { fecharCartao(); if (pres.url) location.href = pres.url + '#roleta-tamanho'; }],
      ['Agora não', function () { fecharCartao(); }]
    ]);
  }

  /* ---------- cartões do rodapé ---------- */
  function css() {
    if (!CFG.css || document.querySelector('link[data-roleta-css]')) return;
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = CFG.css; l.setAttribute('data-roleta-css', '1'); document.head.appendChild(l);
  }
  var cartao = null;
  function fecharCartao() { if (cartao) { cartao.remove(); cartao = null; } }
  function abrirCartao(tipo, html, acoes) {
    css();
    if (cartao && cartao.dataset.tipo === tipo) { cartao.querySelector('[data-texto]').innerHTML = html; return; }
    fecharCartao();
    cartao = document.createElement('div');
    cartao.className = 'roleta-lembrete'; cartao.dataset.tipo = tipo; cartao.setAttribute('role', 'status');
    cartao.innerHTML = '<div data-texto>' + html + '</div><div class="roleta-lembrete__acoes"></div>';
    var box = cartao.querySelector('.roleta-lembrete__acoes');
    acoes.forEach(function (a) { var b = document.createElement('button'); b.type = 'button'; b.textContent = a[0]; b.addEventListener('click', a[1]); box.appendChild(b); });
    document.body.appendChild(cartao);
  }
  function cartoes(d) {
    if (document.documentElement.classList.contains('roleta-aberta')) return;
    var st = d.st, info = d.info;
    if (d.temBrindeKit) { fecharCartao(); return; } // o brinde do kit já vale: sem lembrete do presente da roleta
    // "Adicione mais R$ X": ganhou, tem peça da LP no carrinho e ainda não chegou ao mínimo. Sugere o que fecha a conta.
    if (st.presente && d.temPagas && d.total < d.minimo && !silenciado(K_SIL_FALTA)) {
      var falta = d.minimo - d.total, ref = st.presente.refCalcinha || 0, dica;
      if (ref && falta <= ref) dica = 'uma calcinha já garante';
      else if (ref && falta <= ref * 2) dica = 'duas calcinhas já garantem';
      else dica = 'com mais um sutiã ele vai junto';
      var prazo = st.presente.expira ? '<br><small>Reservado até ' + quando(st.presente.expira) + '.</small>' : '';
      if (!cartao || cartao.dataset.tipo !== 'falta') medir('lembrete_falta_exibido', { falta: falta });
      var alvoTxt = st.presente.nome ? 'a sua <b>' + st.presente.nome + '</b> de presente' : 'o seu presente de <b>' + brl(st.presente.valor || 0) + '</b>';
      abrirCartao('falta', 'Faltam <b>' + brl(falta) + '</b> para ' + alvoTxt + (st.presente.nome ? ' entrar no carrinho.' : ': ' + dica + '.') + prazo, [
        ['Ver as peças', function () { silenciar(K_SIL_FALTA); fecharCartao(); medir('lembrete_falta_clique'); if (st.presente.url) location.href = st.presente.url; }],
        ['Não, obrigada', function () { silenciar(K_SIL_FALTA); fecharCartao(); medir('lembrete_falta_dispensado'); }]
      ]);
      return;
    }
    // "Deixe seu e-mail": girou, saiu sem o e-mail e o carrinho já bate o mínimo.
    if (st.pendente && !st.presente && !st.email && d.temPagas && d.total >= d.minimo && !silenciado(K_SIL_EMAIL)) {
      abrirCartao('email', 'Deixe seu ' + (whats() ? 'WhatsApp' : 'e-mail') + ' e ganhe ' + (st.pendente.nome ? 'a sua <b>' + st.pendente.nome + '</b> de presente' : 'o presente misterioso de <b>' + brl(st.pendente.valor || 0) + '</b>') + '.', [
        [whats() ? 'Deixar meu WhatsApp' : 'Deixar meu e-mail', function () {
          silenciar(K_SIL_EMAIL); fecharCartao(); medir('lembrete_email_clique');
          if (document.querySelector('[data-roleta]')) document.dispatchEvent(new CustomEvent('todaup-roleta:pedir-email'));
          else if (st.pendente.url) location.href = st.pendente.url + '#roleta-email';
        }],
        ['Não, obrigada', function () { silenciar(K_SIL_EMAIL); fecharCartao(); }]
      ]);
      return;
    }
    fecharCartao();
  }

  /* ---------- reforço na página de produto (só para quem girou) ---------- */
  function cartaoProduto() {
    var p = CFG.produto; if (!p) return;
    var st = premio(), info = st.presente || st.pendente;
    var antigo = document.querySelector('.roleta-pdp');
    if (!info || !info.valor || (info.ids || []).map(String).indexOf(String(p.id)) === -1) { if (antigo) antigo.remove(); return; }
    css();
    var texto = p.preco >= (info.minimo || 0) ? 'Vai junto no seu pedido' : 'Em pedidos a partir de ' + brl(info.minimo || 0);
    if (!st.presente) texto += ' · deixe seu ' + (whats() ? 'WhatsApp' : 'e-mail') + ' para liberar';
    else if (st.presente.expira) texto += '<br><small>Reservado até ' + quando(st.presente.expira) + '</small>';
    var html = '<span class="roleta-pdp__icone" aria-hidden="true">?</span><span class="roleta-pdp__texto"><b>Presente misterioso</b><span><strong>' + brl(info.valor) + '</strong> grátis · ' + texto + '</span></span>';
    if (antigo) { antigo.innerHTML = html; return; }
    var alvo = document.querySelector('kit-exclusivo') || document.querySelector('.product-form__buy-buttons') || document.querySelector('product-form, .product-form');
    if (!alvo) return;
    var box = document.createElement('div'); box.className = 'roleta-pdp'; box.innerHTML = html;
    alvo.parentNode.insertBefore(box, alvo.nextSibling);
  }

  function tudo() { conferir(); cartaoProduto(); }
  document.documentElement.addEventListener('cart:updated', function (e) { if (e.detail && e.detail.source === 'roleta') return; conferir(); });
  document.addEventListener('todaup-roleta:presente', tudo);
  document.addEventListener('todaup-roleta:fechou', function () { conferir(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tudo); else tudo();
})();
